module.exports = __webpack_public_path__ + "static/media/sitemap.18b0ccfa.png";